import * as React from "react"
import Box from '@mui/material/Box';
import Fluid from 'components/Fluid'
import { ReactComponent as LongArrow } from "images/long_arrow.svg";

const ComparisonCardsContentLink = ({cards, title, flush, background, backgroundImage, backgroundProps, padding, ...props}) => {

	const speed = 3500;

	const sectionInlineStyle = {
		...(backgroundImage ? {
			backgroundImage: `url(${process.env.CDN_DOMAIN||''}${backgroundImage}?max-w=1280&format=webp&quality=60)`,
			...(backgroundProps ? {
				...(backgroundProps.indexOf('cover') !== -1 ? {
					backgroundSize: 'cover',
				} : null),
				...(backgroundProps.indexOf('fixed') !== -1 ? {
					backgroundAttachment: 'fixed',
				} : null),
				...(backgroundProps.indexOf('repeat') !== -1 ? {
					backgroundRepeat: 'repeat',
				} : {backgroundRepeat: 'no-repeat'}),
			} : null),
		} : null),
	}

	const [imageLayout, setImageLayout] = React.useState(0);
	const [activeSlide, setActiveSlide] = React.useState(0);
	const layoutRatios = [
		['66.66%', '33.33%'],
		['50%', '50%'],
		['33.33%', '66.66%'],
	]

	const [intervalId, setIntervalId] = React.useState(null);

	const resetInterval = () => {
		clearInterval(intervalId);

		const id = setInterval(() => {
			slideChange();
		}, speed);
		setIntervalId(id);
	};

	const changeLayout = () => {
		setImageLayout(layout => { 
			if (layout === 0) {
				return 1;
			} else if (layout === 1) {
				return 2;
			} else {
				return 0;
			}
		});
	}

	const navClick = (index=0) => {
		if (index !== activeSlide) {
			changeLayout();
			setActiveSlide(index);
			resetInterval();
		}
	}

	const slideChange = React.useCallback(() => {
		changeLayout();
		setActiveSlide(slide => {
			let slideCount = cards.length;
			if (slide < slideCount - 1) {
				return slide + 1;
			} else {
				return 0;
			}
		});
	}, [cards.length]);

	React.useEffect(() => {
		if (cards.length > 1) {
			const id = setInterval(() => {
				slideChange();
			}, speed);
			setIntervalId(id);

			return () => clearInterval(id);
		}
	}, [cards?.length, slideChange]);

	return (
		<Box 
			sx={(Object.keys(sectionInlineStyle).length > 0 ? sectionInlineStyle : null)}
			className={[
				'comparisonCardsContentLink__section', 
				(padding ? 'padding-normal' : ''), 
				(flush ? 'margin-flush' : ''),
				(background||'')
			].join(' ')}
		>
			<Fluid layout="12" className="comparisonCardsContentLink__navigation">
				<Box className="comparisonCardsContentLink__bullets">
					{cards && (cards.length > 1) && cards.map((card, index) => {
						return (
							<button key={`card_${index}_nav`} aria-label={`card_${index}_navigation`} className={[
								'comparisonCardsContentLink__bullet',
								(index === activeSlide ? 'comparisonCardsContentLink__bullet-active' : ''),
							].join(' ')} onClick={() => {navClick(index)}} />
						)
					})}
				</Box>
			</Fluid>
			<Fluid layout={{ms:"7 5"}} className="comparisonCardsContentLink__content">
				<Box className="comparisonCardsContentLink__title_wrapper">
					{title && <p className="comparisonCardsContentLink__subtitle">{title}</p>}
					<h2 className="comparisonCardsContentLink__title" style={{transition: 'all .3s'}}>{cards[activeSlide]['title']}</h2>
				</Box>
				<Box className="comparisonCardsContentLink__body_wrapper">
					{cards[activeSlide]['description'] && <p className="comparisonCardsContentLink__description">{cards[activeSlide]['description']}</p>}
					{cards[activeSlide]['link'] && <a className="comparisonCardsContentLink__link" href={cards[activeSlide]['link']}>
						<span className="comparisonCardsContentLink__linkText">{cards[activeSlide]['linkText'] ? cards[activeSlide]['linkText'] : 'Discover'}</span>
						<span className="comparisonCardsContentLink__linkText__arrow" aria-hidden="true"><LongArrow /></span></a>}
				</Box>
			</Fluid>
			<Fluid layout="12" bleed="both" className="comparisonCardsContentLink__images_wrapper">
				<Box className="comparisonCardsContentLink__images_grid">
					<div className="comparisonCardsContentLink__image_one comparisonCardsContentLink__image" style={{
						width: layoutRatios[imageLayout][0],
						backgroundImage: `url(${cards[activeSlide]['image1']}?max-w=1280&format=webp&quality=60)`,
					}} />
					<div className="comparisonCardsContentLink__image_two comparisonCardsContentLink__image" style={{
						width:  layoutRatios[imageLayout][1],
						backgroundImage: `url(${cards[activeSlide]['image2']}?max-w=1280&format=webp&quality=60)`,
					}} />
				</Box>
			</Fluid>
		</Box>
	)
}

export default React.memo(ComparisonCardsContentLink);